import {
  ComposedChart,
  Bar,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";

interface Datum {
  month: string;
  catheter_qty: number;
  catheters_per_monitor: number | null;
}

const monthLabel = (m: string) => {
  const [y, mm] = m.split("-").map(Number);
  return new Date(Date.UTC(y, mm - 1, 1)).toLocaleDateString("en-US", {
    month: "short",
    year: "2-digit",
  });
};

export default function MonthlyUsageChart({
  data,
  height = 280,
}: {
  data: Datum[];
  height?: number;
}) {
  const formatted = data.map((d) => ({ ...d, label: monthLabel(d.month) }));
  return (
    <div style={{ width: "100%", height }}>
      <ResponsiveContainer>
        <ComposedChart data={formatted} margin={{ top: 10, right: 20, left: 0, bottom: 4 }}>
          <CartesianGrid stroke="#e5e7eb" vertical={false} />
          <XAxis
            dataKey="label"
            stroke="#9ca3af"
            tick={{ fontSize: 11 }}
            tickLine={false}
            axisLine={false}
          />
          <YAxis
            yAxisId="left"
            stroke="#9ca3af"
            tick={{ fontSize: 11 }}
            tickLine={false}
            axisLine={false}
            allowDecimals={false}
          />
          <YAxis
            yAxisId="right"
            orientation="right"
            stroke="#9ca3af"
            tick={{ fontSize: 11 }}
            tickLine={false}
            axisLine={false}
          />
          <Tooltip
            cursor={{ fill: "rgba(15,23,42,0.04)" }}
            contentStyle={{
              border: "1px solid #e5e7eb",
              borderRadius: 8,
              fontSize: 12,
              boxShadow: "0 1px 2px rgba(15,23,42,0.06)",
            }}
            formatter={(value: number, name: string) => {
              if (name === "Catheters") return [value.toLocaleString(), "Catheters"];
              if (name === "Per monitor") return [value?.toFixed?.(2) ?? "—", "Catheters / monitor"];
              return [value, name];
            }}
          />
          <Legend wrapperStyle={{ fontSize: 11 }} />
          <Bar yAxisId="left" dataKey="catheter_qty" name="Catheters" fill="#c7d2fe" radius={[4, 4, 0, 0]} />
          <Line
            yAxisId="right"
            dataKey="catheters_per_monitor"
            name="Per monitor"
            stroke="#4f46e5"
            strokeWidth={2}
            dot={{ r: 3 }}
            connectNulls
          />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
}
